import { PlusCircleOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  message,
  Divider,
  Spin,
  TreeSelect,
  InputNumber,
  Select,
  Input,
} from "antd";
import React, { useEffect, useState } from "react";
import { store } from "../../../redux/configStore";
import { transformData } from "../../../utils/recursive";
import useStoreData from "../../../hooks/useStoreData";
import {
  createMapServiceBranch,
  getListMapServiceBranch,
} from "../../../api/mapServiceBranch/mapServiceBranch";
import { getListService } from "../../../api/serviceProject/service";

export default function FormAddMapServiceBranch({
  isModalOpen,
  handleCancel,
  currentPage,
  pageSize,
}) {
  const { data: allListStore, loading: isLoadStoreAll } = useStoreData();

  const { listService, isLoadService } = useSelector(
    (state) => state.persistedReducer.servicesSlice
  );

  const [isLoadCreate, setIsLoadCreate] = useState(false);
  const [formRef] = Form.useForm();
  const dispatch = useDispatch();

  const data = transformData(allListStore?.data);
  const options = data?.filter((item) => item.parent_id === 0);

  useEffect(() => {
    const fetchData = async () => {
      const requests = [];
      requests.push(
        store.dispatch(getListService({ currentPage: 1, pageSize: 100 }))
      );

      await Promise.all(requests);
    };

    fetchData();
  }, []);

  const onFinish = async (fieldsValue) => {
    const values = { ...fieldsValue };
    setIsLoadCreate(true);

    try {
      const response = await store.dispatch(createMapServiceBranch(values));
      if (createMapServiceBranch.fulfilled.match(response)) {
        if (response.payload.data.original) {
          message.error(response.payload.data.original.message);
        } else {
          message.success("Thêm mới thành công");
          formRef.resetFields();
          handleCancel();
          await store.dispatch(
            getListMapServiceBranch({ currentPage, pageSize })
          );
        }
      } else if (createMapServiceBranch.rejected.match(response)) {
        handleErrors(response);
      }
    } catch (error) {
      message.error("Đã xảy ra lỗi khi tạo.");
    } finally {
      setIsLoadCreate(false);
    }
  };

  // Hàm xử lý lỗi từ API
  const handleErrors = (response) => {
    if (response.payload.errors) {
      Object.keys(response.payload.errors).forEach((field) => {
        const errorMessages = response.payload.errors[field];
        errorMessages.forEach((errorMessage) => {
          message.error(errorMessage);
        });
      });
    } else if (response.payload.error) {
      message.error(response.payload.error);
    }
    if (response.payload.message) {
      message.error(response.payload.message);
    }
  };

  return (
    <Modal
      title="Thiết lập thông tin liên kết dữ liệu"
      open={isModalOpen}
      footer={null}
      onCancel={handleCancel}
      width={"50%"}
    >
      <Form
        name="addMapServiceBranch"
        form={formRef}
        onFinish={onFinish}
        layout="vertical"
        requiredMark=""
      >
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              label="Đơn vị"
              name="mcoupon_branch_id"
              rules={[{ required: true, message: "Vui lòng chọn đơn vị" }]}
            >
              {isLoadStoreAll ? (
                <Spin />
              ) : (
                <TreeSelect
                  allowClear
                  showSearch
                  treeLine
                  treeData={options}
                  placeholder="Vui lòng chọn đơn vị"
                  filterTreeNode={(inputValue, treeNode) =>
                    treeNode.title
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  }
                />
              )}
            </Form.Item>

            <Form.Item
              label="Loại dịch vụ"
              name="service_id"
              rules={[
                { required: true, message: "Vui lòng chọn loại dịch vụ" },
              ]}
            >
              <Select
                placeholder="Chọn loại dịch vụ"
                allowClear
                showSearch
                optionFilterProp="children"
                options={(listService || [])?.map((type) => ({
                  label: type.name,
                  value: type.id,
                }))}
              />
            </Form.Item>
            <Row>
              <Col span={24}>
                <Form.Item
                  label="Mã doanh nghiệp (ID)"
                  name="business_id"
                  rules={[
                    {
                      required: false,
                      message: "Vui lòng nhập mã doanh nghiệp",
                    },
                  ]}
                >
                  <Input placeholder="Nhập mã doanh nghiệp" />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col xs={24} sm={12} md={8} span={8}>
                <Form.Item
                  label="Version"
                  name="version"
                  rules={[
                    {
                      required: false,
                      message: "Vui lòng nhập tên Version",
                    },
                  ]}
                >
                  <Input placeholder="Nhập tên Version" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} span={8}>
                <Form.Item
                  label="APP ID"
                  name="appId"
                  rules={[
                    {
                      required: false,
                      message: "Vui lòng nhập tên APP ID",
                    },
                  ]}
                >
                  <Input placeholder="Nhập tên APP ID" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} span={8}>
                <Form.Item
                  label="Verify Token"
                  name="verify_token"
                  rules={[
                    {
                      required: false,
                      message: "Vui lòng nhập tên Verify Token",
                    },
                  ]}
                >
                  <Input placeholder="Nhập tên Verify Token" />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item
                  label="Access Token"
                  name="accessToken"
                  rules={[
                    {
                      required: false,
                      message: "Vui lòng nhập tên Access Token",
                    },
                  ]}
                >
                  <Input placeholder="Nhập tên Access Token" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24} style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="submit"
              icon={<PlusCircleOutlined />}
              loading={isLoadCreate}
              style={{ minWidth: 150 }}
            >
              Thêm mới
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
